import React, { useEffect, useRef, useState } from 'react';
import { Tooltip, DatePicker, InputNumber, Radio } from 'antd';
import { QuestionCircleTwoTone } from '@ant-design/icons';
import moment from 'moment';
const dateFormat = 'YYYY-MM-DD';

const RightView = (props) => {
  const {
    rightActivateMode,
    setRightActivateMode,
    rightActivateValue,
    setRightActivateValue,
  } = props;
  const ref = useRef();

  useEffect(() => {}, [ref]);

  // 权益激活方式
  const rightActivateValueChange = (e) => {
    if (!setRightActivateMode) {
      return;
    }
    setRightActivateValue(null);
    setRightActivateMode(e.target.value);
  };
  const onRightDayChange = (day) => {
    if (!setRightActivateValue) {
      return;
    }
    setRightActivateValue(day);
  };
  // 权益激活方式 时间变化监听
  const onRightDateChange = (date) => {
    if (!setRightActivateValue) {
      return;
    }
    setRightActivateValue(date?.format(dateFormat));
  };


  return (
    <Radio.Group
      value={rightActivateMode}
      onChange={rightActivateValueChange}
      style={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Radio value={1}>购买后立即激活</Radio>
      <Radio
        style={{
          paddingTop: 10,
        }}
        value={2}
      >
        购买后指定天数激活
        <a hidden={rightActivateMode !== 2}>
          <InputNumber
            style={{
              padding: 0,
              marginTop: -5,
              marginLeft: 5,
              width: 160,
            }}
            addonAfter="天"
            min={1}
            max={90}
            value={rightActivateValue}
            onChange={onRightDayChange}
            placeholder="1~90的整数"
          />
          <Tooltip title="购买后N天内，只要用户使用则立即激活，不使用的话则到第N天才自动激活。">
            <QuestionCircleTwoTone style={{ fontSize: 18, marginLeft: 5 }} />
          </Tooltip>
        </a>
      </Radio>
      <Radio
        style={{
          paddingTop: 10,
        }}
        value={3}
      >
        预售指定日期激活
        <a hidden={rightActivateMode !== 3}>
          <DatePicker
            value={
              rightActivateValue ? moment(rightActivateValue) : null
            }
            style={{
              width: 160,
              marginLeft: 19,
            }}
            picker="date"
            format={dateFormat}
            onChange={onRightDateChange}
          />
          <Tooltip title="指定特定的日期00:00:00激活，在日期之前不会激活无法使用，购买日期超过该日期则立即激活">
            <QuestionCircleTwoTone style={{ fontSize: 18, marginLeft: 5 }} />
          </Tooltip>
        </a>
      </Radio>
    </Radio.Group>
  );
};

export default RightView;
